import React from 'react';
import { useCommentLayoutContext } from '../../CommentLayoutProvider';
import EmptyMessageList from './EmptyMessageList';
import MessageList from './MessageList';

export default function MessageListPicker() {
  const {
    messageResourceList,
  } = useCommentLayoutContext();

  if (!messageResourceList) {
    return null;
  }

  if (messageResourceList?.length === 0) {
    return (<EmptyMessageList />);
  }

  return (
    <MessageList />
  );
}
